"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAuthTokenInfo = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _reactRedux = require("react-redux");

var _ramda = require("ramda");

var _store = require("../store");

var _useAuthService2 = require("./useAuthService");

var transparentPaths = ['/callback', '/auth/login', '/login/redirect', '/confirm'];

var useAuthTokenInfo = function useAuthTokenInfo() {
  var _useAuthService = (0, _useAuthService2.useAuthService)(),
      tokenService = _useAuthService.tokenService;

  var dispatch = (0, _reactRedux.useDispatch)();
  var token = tokenService.getToken();
  var isAuthenticated = (0, _reactRedux.useSelector)(_store.getIsAuthenticated);
  (0, _react.useEffect)(function () {
    var currentPath = window.location.pathname;
    var tokenInfo = {
      isValid: false
    };
    var isExpired = true;

    if (token) {
      tokenInfo = tokenService.getDecodedToken();
      isExpired = tokenService.isExpired();
    }

    var isTokenAlive = tokenInfo.isValid && !isExpired;
    var needRefreshToken = !isTokenAlive && !transparentPaths.some(function (path) {
      return currentPath.startsWith(path);
    });

    if (isTokenAlive) {
      var _ref = tokenInfo,
          name = _ref.name,
          email = _ref.email,
          image = _ref.image,
          roles = _ref.roles,
          grants = _ref.grants,
          _ref$admin_sub = _ref.admin_sub,
          adminId = _ref$admin_sub === void 0 ? null : _ref$admin_sub;

      var _split = (0, _ramda.split)(' ', name),
          _split2 = (0, _slicedToArray2.default)(_split, 2),
          firstName = _split2[0],
          lastName = _split2[1];

      dispatch((0, _store.updateUserInfoFields)({
        firstName,
        lastName,
        image,
        email,
        roles,
        adminId,
        permissions: (0, _ramda.values)(grants)
      }));
      dispatch((0, _store.authComplete)());
    }

    if (needRefreshToken) {
      dispatch((0, _store.refreshTokenRequest)());
    }
  }, [dispatch, token, tokenService]);
  return [isAuthenticated, token];
};

exports.useAuthTokenInfo = useAuthTokenInfo;